import React from "react";
import { Link, useLocation } from "react-router-dom";

const RRTestHeader = () => {
  const location = useLocation();

  const isActive = (path:any) => location.pathname === path;
  return (
    <div className="bg-[#F6F6F6]">
       <div className="w-full max-w-2xl mx-auto flex flex-row justify-between gap-5 px-10 py-[19px]">
    <Link to="/rrteststep1"
      className={`text-base font-normal pb-[4px] ${
        isActive('/rrtestresult1') ? 'text-black border-b border-black' : 'text-[#a5a5a5]'
      }`}
    >
      Test
    </Link>
    <Link to="/rrtrain"
      className={`text-base font-normal pb-[4px] ${
        isActive('/rrtrain') ? 'text-black border-b border-black' : 'text-[#a5a5a5]'
      }`}
    >
      Train
    </Link>
    <Link to="/rrperfomance"
      className={`text-base font-normal pb-[4px] ${
        isActive('/rrperfomance') ? 'text-black border-b border-black' : 'text-[#a5a5a5]'
      }`}
    >
      Performance
    </Link>
  </div>
    </div>
  );
};

export default RRTestHeader;
